import React from 'react';

const Table = ({ data }) => {
  return (
    <table className="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Company Name</th>
          <th>Symbol</th>
          <th>Quantity</th>
          <th>Average Price</th>
          <th>Last Price</th>
          <th>Day Change</th>
          <th>P&L</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>{item.company_name}</td>
            <td>{item.trading_symbol}</td>
            <td>{item.quantity}</td>
            <td>{item.average_price}</td>
            <td>{item.last_price}</td>
            <td
              style={{
                color: item.day_change > 0 ? 'green' : 'red',
              }}
            >
              {item.day_change} ({item.day_change_percentage}%)
            </td>
            <td
              style={{
                color: item.pnl > 0 ? 'green' : 'red',
              }}
            >
              {item.pnl}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
